$(function () {
    // Global variable
    var $swatchCollection = {
        collection_items: $('#SwatchCollection .swatch-collection .swatch-item')
    };

    // Handles Swatch Collection Filters    
    $('.custom-checkbox').on('click', function () {
        $(this).parent().find('input[type=checkbox]').click();
    });

    //On checkbox click
    $('input[type=checkbox]').click(function () {
        var arrSelected = []; // Create Array of Values
        var arrTypes = []; // Create Array of Types
        $('input:checkbox:checked').each(function () {
            if (arrSelected[$(this).prop('name')] == undefined) {
                arrSelected[$(this).prop('name')] = [];
            }
            arrSelected[$(this).prop('name')].push($(this).val());
            if ($.inArray($(this).prop('name'), arrTypes) < 0) {
                arrTypes.push($(this).prop('name'));
            }
        });

        // get all swatch-item elements
        var $filteredResults = $('#SwatchCollection .swatch-collection .swatch-item');

        // Filter items by data props
        $filteredResults.each(function () {
            $(this).fadeOut();
            var intKeyCount = 0;
            for (key in arrTypes) { // AND (check count of matching types)
                var blnFound = false;
                for (val in arrSelected[arrTypes[key]]) { // OR (check one of values matches type)                    
                    if ($(this).attr('data-' + arrTypes[key]) == arrSelected[arrTypes[key]][val]) {
                        //if ($(this).attr('data-' + arrTypes[key]).indexOf(arrSelected[arrTypes[key]][val]) > -1) {                       
                        blnFound = true;
                        break;
                    }
                }
                if (blnFound) {
                    intKeyCount++;
                }
            }
            if (intKeyCount > 0 && intKeyCount != arrTypes.length - 1) {
                $(this).fadeIn('slow');
                $(this).find('.also-available').show();
            }
        }).promise().done(function () {
            // On complete, check if all DIVs are display none and show/hide message
            if ($('.swatch-item').is(':visible') == false) {
                $('.no-result-found').show();
            } else {
                $('.no-result-found').hide();
            }
        });

        // If there are no filters, show everything
        if (arrSelected.length == 0 && arrTypes.length == 0) {
            $swatchCollection.collection_items.fadeIn('slow');
            $('.also-available').hide();
            $('.no-result-found').hide();
        }
    });
});